<template lang="pug">
div.radio-squares
    span.checkbox(
        v-for="item in items",
        :class="{checked: value === item}",
        @click="change(item)"
    ) {{item.label}}
</template>

<script>
export default {
    props: {
        value: {
            type: [String, Number, Object]
        },
        items: {
            type: Array,
            required: true
        }
    },
    methods: {
        change(item) {
            this.$emit('input', item);
        }
    }
};
</script>

<style scoped>
.radio-squares .checkbox {
    display: inline-block;
    padding-left: 20px;
    margin-right: 15px;
    cursor: pointer;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAElBMVEX////d4Ord4Ofd3+va4eje4OV0/av1AAAAO0lEQVQI12NwVTI2ElJScmUIYAADJgYFNAYLgwGEwQhjMCEYDjApAQyGApyBLgXXhTA5SEVIUVBQUBQAg8wErikP7a8AAAAASUVORK5CYII=) left center no-repeat;
}

.radio-squares .checkbox.checked {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAe1BMVEX//////v////39///c4Ond4ef+/v3e4OUnvE7d4OsovEwqvVDb4OnZ4Oip5Lj7/fr2/ffc3uri9ufA68pv04xOym1BxmQ7wV0uwFYlvEzw+vLs+fDp9u3c89/W893Q8NnN79ae4LCS3aWH2J131Ytr0Ydeznxhzns2wVy3gNuAAAAAsklEQVQY0y2PV3IEMQhEm0YgjSZsTs7Zvv8J3VO1/Kh4rUcB5hoxDLsotUTEVFENKrqBgHlFIAXS9BjBQIinSDoV+IRBDZnm2B4XWlkBqMgefsbbh4QdEyn2dGptXDwww/YH2vO5tesBLsVfLuPy9tf65RXrjMLv3m/X1s97M0NBYHMce2+nRybdBIz+ObbfrWJHSgHg71+bdHdAP2YDSHV0KVwXS4ciQgkk1BqTDi/3qv+EGQbH70lusQAAAABJRU5ErkJggg==);
}
</style>



// WEBPACK FOOTER //
// radio-square.vue?1f83cd50